const GetProductId = (provider) => {
    let PRODUCT_ID, COUPON_ID
    switch (provider) {
        case 'cafe24':
            // 번들 결제 통신할때 필요한 파라미터
            PRODUCT_ID = "63243e2bc2cb943c903d291a"
            // 번들 결제 쿠폰 아이디
            COUPON_ID = "63318c48c2cb943c9086cd2d"
            break

        case '':
        case undefined:
        case 'undefined':
        case null:
        case 'null':
            // 영상 제작(1편) 결제 통신할때 필요한 파라미터
            PRODUCT_ID = "6396d1a4c2cb943c90696dc3"
            // 영상 제작(1편) 쿠폰 아이디
            COUPON_ID = "6396d208c2cb943c9069724a"
            break

        default:
            PRODUCT_ID = null
            COUPON_ID = null
            break
    }
    return { PRODUCT_ID, COUPON_ID }
}

/**
 * 편당결제 쿠폰아이디와 동일한지 확인 하고 restCount가 0이 아니면 true
 * @param  {{
 *  restCount: number
*   couponid: string
 * }} couponInfo
 * @param {string} provider
 * @returns boolean
 */
const IsValidCoupon = (couponInfo, provider) => couponInfo.restCount > 0 && couponInfo.couponid === GetProductId(provider).COUPON_ID

/**
 * 보유한 쿠폰들을 만료일이 제일 최근인 순으로 정렬한뒤에 제일 첫번째 편당결제 쿠폰 정보를 반환
 * @param  {Array} coupons
 * @param  {string} provider
 * @returns {Object | undefined}
 */

const GetCouponInfo = (coupons, provider) => coupons.sort((a, b) => new Date(a.expiredAt) - new Date(b.expiredAt)).find((coupon) => coupon.couponid === GetProductId(provider).COUPON_ID)



export default {
    IsValidCoupon,
    GetCouponInfo,
    GetProductId
}